import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/noordgastransport.webp';
import screenshot_target from '../../../images/letterfunnel/pierrebartholomeus.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Pierre Bartholomeus"
      firstname="Pierre"
      companyname="Noordgastransport"
      competition="NOGAT en Westgas Transport"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/pierrebartholomeus.js